export default __webpack_public_path__ + "static/media/laravel.38586ff6.svg";